<section class="class-container">
  <div class="box-one">
    <div>
      <label for="attendanceDate">Select a Date</label>

      <input id="attendanceDate" type="date" [(ngModel)]="attendanceDate" name="attendanceDate"
             (change)="onDateChange()">
    </div>

    @if (attendanceDate) {
        <div class="filter-field search-field">
          <label for="studentSearch">Search Student</label>

          <input id="studentSearch" type="search" [(ngModel)]="search" name="search"
                 (input)="applyFilters()" placeholder="Search by student name...">
        </div>

        <div class="filter-field status-field">
          <label for="attendanceStatus">Status</label>

          <select id="attendanceStatus" [(ngModel)]="attendanceStatus" name="attendanceStatus"
                  (change)="applyFilters()">
            <option value="">All statuses</option>
            <option value="PRESENT">Present</option>
            <option value="ABSENT">Absent</option>
          </select>
        </div>
    }
  </div>

  <section class="box-two">
    <div class="attendance-day">
      <div>
        <h6>Student Register</h6>
        @if (attendanceDate) {
          <p class="light-color">{{ Helpers.formatDate(attendanceDate) }}</p>
        }
      </div>

      @if (attendanceDate) {
        <div class="attendance-check">
        <div class="status">
          <p class="PRESENT">{{ attendanceSummary?.present ?? 0 }} PRESENT</p>
        </div>

        <div class="status">
          <p class="ABSENT">{{ attendanceSummary?.absent ?? 0 }} ABSENT</p>
        </div>
      </div>
      }
    </div>

    @if (attendanceDate) {
      <div class="poles">
      <div class="green-pole" [style.width.%]="attendanceSummary?.presentPercentage ?? 0"></div>
      <div class="red-pole" [style.width.%]="attendanceSummary?.absentPercentage ?? 0"></div>
    </div>
    }

    <div>
      @if (isFiltering()) {
        <app-loading-indicator />
      } @else {
        @if (attendanceReports()?.payload?.length) {
          @for (attendance of attendanceReports()?.payload; track $index) {
            <div class="attendance-list">
              <div class="q">
                <div class="name">
                  <p class="light-color">{{ $index + 1 }}</p>
                </div>

                <div class="name-stu-id">
                  <button type="button" class="student-link"
                          (click)="navigateToStudentDetail(attendance.student_id)">
                    {{ attendance.first_name }} {{ attendance.last_name }}
                  </button>

                  <p class="light-color">{{ attendance.student_public_id }}</p>
                </div>
              </div>

              <div class="status">
                <p [ngClass]="attendance.attendance_status">{{ attendance.attendance_status }}</p>
              </div>
            </div>
          }
        } @else {
          <div class="no-history">
            <h6>ADJUST DATE FILTERS</h6>
          </div>
        }
      }
    </div>

  </section>

  <app-pagination
    [page]="attendanceReports()?.pagination?.page ?? 0"
    [size]="attendanceReports()?.pagination?.size ?? 10"
    [totalElements]="attendanceReports()?.pagination?.totalElements ?? 0"
    [totalPages]="attendanceReports()?.pagination?.totalPages ?? 0"
    [first]="attendanceReports()?.pagination?.first ?? true"
    [last]="attendanceReports()?.pagination?.last ?? false"
    [hasNext]="attendanceReports()?.pagination?.hasNext ?? false"
    [hasPrevious]="attendanceReports()?.pagination?.hasPrevious ?? false"
    (pageChange)="loadPage($event)">
  </app-pagination>

</section>

